/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingConfiguration } from '../../models/charging-configuration';

export interface ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Params {
  chargerId: string;
  connectorId: number;
}

export function apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
  const rb = new RequestBuilder(rootUrl, apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('chargerId', params.chargerId, {});
    rb.path('connectorId', params.connectorId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargingConfiguration>;
    })
  );
}

apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain.PATH = '/api/ChargingConfiguration/GetByChargerIdAndConnectorId/{chargerId}/{connectorId}';
